var module = angular.module('octopusApp.projects');

module.directive('azureResourceGroupSelector', function () {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            model: '=',
            projectId: '=',
            getAccountId: '=',
            isAccountBound: '='
        },
        templateUrl: 'areas/projects/actions/azure_resource_group/azure_resource_group_selector.html',
        controllerAs: 'vm',
        controller: function ($scope, octopusRepository, busy, $timeout) {
            var vm = this;
            vm.model = $scope.model;
            vm.projectId = $scope.projectId;
            var getAccountId = $scope.getAccountId;
            vm.isLoading = busy.create();
            vm.changed = changed;

            vm.reset = {
                name: undefined,
            };

            function changed() {
                if (vm.selectedResourceGroup) {
                    vm.model.name = vm.selectedResourceGroup.Name;
                } else {
                    vm.model.name = null;
                }
            }

            $scope.$watch(getAccountId,
                function () {
                    if (!getAccountId()) {
                        vm.isLoading.promise($timeout(function () {
                            vm.resourceGroups = [];
                        }, 100));
                        return;
                    }

                    vm.isLoading.promise(octopusRepository.Accounts.get(getAccountId())
                            .then(function (account) {
                                return octopusRepository.Accounts.getResourceGroups(account)
                                    .then(function (resourceGroups) {
                                        vm.resourceGroups = resourceGroups;

                                        if (vm.model.name) {
                                            vm.selectedResourceGroup = resourceGroups.filter(function (resourceGroup) {
                                                return resourceGroup.Name === vm.model.name;
                                            })[0];
                                        }
                                    }, function (error) {
                                        vm.resourceGroupError = error.ErrorMessage;
                                    });
                            })
                    );
                }
            );
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/azure_resource_group/azure_resource_group_selector.js
// module id = 4443760598011168
// module chunks = 1